import PropTypes from 'prop-types';
import React from 'react';

import { Button, FullScreenCta } from '@coursera/components';

import styles from './plugin-container-home.module.scss';

export const PluginContainerHome = ({
  image,
  header,
  subheader,
  subheader2,
  subheaderBold,
  next,
  className,
}) => {
  return (
    <div className={className}>
      <section className={styles.home}>
        <header>
          <h1>{header}</h1>
          {subheaderBold && <p className={styles.bold}>{subheaderBold}</p>}
          <p>{subheader}</p>
          {subheader2 && <p>{subheader2}</p>}
        </header>
        <img src={image} alt="Welcome image" />
      </section>
      <Button.Container fixed>
        <Button autoFocus={true} onClick={next}>
          Continue
        </Button>
      </Button.Container>
      <FullScreenCta />
    </div>
  );
};

PluginContainerHome.propTypes = {
  className: PropTypes.string,
  image: PropTypes.any,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subheader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subheader2: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subheaderBold: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  next: PropTypes.func,
};
